var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fields" }, [
    _c("label", [_vm._v(_vm._s(_vm.field.price))]),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { staticClass: "help" }, [_vm._v(_vm._s(_vm.field.help))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }